export default __webpack_public_path__ + "static/media/Icethorn.01a2fc15.jpg";